export const ValidateInput = (inputData, schema, schemaType, type = null) => {
  let errors = {};
  let status = true;
  const keysToValidate = type ? [type] : Object.keys(schemaType[schema]);

  keysToValidate.forEach((key) => {
    const field = schemaType[schema][key];
    const value = inputData[key] ? inputData[key] : "";
    if (field.required && (!value || value === undefined || value === "")) {
      errors[key] = field?.message;
      if (field.extraMessage) {
        errors[`${key}Err`] = true;
      }
      status = false;
    } else if (field.validate && !field.validate(value, inputData)) {
      if (field.extraMessage) {
        errors[`${key}Err`] = true;
        errors[key] = field.invalidMessage;
      }
      status = false;
    }
  });

  return { errors, status };
};

export const removeErrorFields = (errorObject, fieldName) => {
  const updatedError = { ...errorObject };

  // Remove the specific field and its associated error
  if (updatedError[fieldName]) delete updatedError[fieldName];
  if (updatedError[`${fieldName}Err`]) delete updatedError[`${fieldName}Err`];

  return updatedError;
};
